/* Minha Kidz account dashboard navigation; scoped, no customer data stored in browser. */
(function () {
  'use strict';
  function init(root) {
    if (!root || root.dataset.mkAccountInitialized === 'true') return;
    root.dataset.mkAccountInitialized = 'true';
    var tabs = ['overview', 'orders', 'profile', 'rewards'];
    var controls = Array.prototype.slice.call(root.querySelectorAll('[data-mk-account-tab]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-mk-account-panel]'));
    if (!panels.length) return;
    function currentTab() {
      var params = new URLSearchParams(window.location.search);
      var tab = params.get('tab');
      if (tabs.indexOf(tab) !== -1) return tab;
      if (params.get('page')) return 'orders';
      return 'overview';
    }
    function show(tab, push) {
      if (tabs.indexOf(tab) === -1) tab = 'overview';
      panels.forEach(function (panel) { panel.hidden = panel.getAttribute('data-mk-account-panel') !== tab; });
      controls.forEach(function (control) {
        var active = control.getAttribute('data-mk-account-tab') === tab;
        if (control.closest('.mk-account__nav')) {
          if (active) control.setAttribute('aria-current', 'page');
          else control.removeAttribute('aria-current');
        }
      });
      if (push) {
        var url = new URL(window.location.href);
        url.searchParams.delete('open_joy');
        url.searchParams.delete('page');
        if (tab === 'overview') url.searchParams.delete('tab');
        else url.searchParams.set('tab', tab);
        window.history.pushState({ mkAccountTab: tab }, '', url.pathname + url.search + url.hash);
      }
    }
    controls.forEach(function (control) {
      control.addEventListener('click', function (event) {
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;
        event.preventDefault();
        show(control.getAttribute('data-mk-account-tab'), true);
        var title = root.querySelector('[data-mk-account-panel="' + control.getAttribute('data-mk-account-tab') + '"] .mk-account__section-head h2');
        if (title) {
          title.setAttribute('tabindex', '-1');
          title.focus({ preventScroll: false });
        }
      });
    });
    window.addEventListener('popstate', function () { show(currentTab(), false); });
    show(currentTab(), false);
  }
  function setup() { document.querySelectorAll('[data-mk-account-root]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup);
  else setup();
  document.addEventListener('shopify:section:load', setup);
}());
